import { useTranslation } from "next-i18next"
import parse from "html-react-parser"

const useDealershipEnquiry = (authorData = {}) => {
  const { t } = useTranslation()
  const i18n = {
    dealershipTitle: authorData?.dealershipTitle
      ? parse(authorData?.dealershipTitle.replaceAll("&amp;nbsp;", " "))
      : t("kf.dealershipEnquiry.dealershipTitle"),
    dealershipFormDescription: authorData?.dealershipFormDescription
      ? parse(
          authorData?.dealershipFormDescription.replaceAll("&amp;nbsp;", " ")
        )
      : t("kf.dealershipEnquiry.dealershipFormDescription"),
    cities: authorData?.cities,
    spaceAvailableItems: authorData?.spaceAvailableItems,
    budgetItems: authorData?.budgetItems,
    mobileNumber: t("kf.dealershipEnquiry.mobileNumber"),
    mobileNumberDescription: t("kf.dealershipEnquiry.mobileNumberDescription"),
    firstNameError: t("kf.dealershipEnquiry.firstNameError"),
    lastNameError: t("kf.dealershipEnquiry.lastNameError"),
    firstName: t("kf.dealershipEnquiry.firstName"),
    lastName: t("kf.dealershipEnquiry.lastName"),
    emailAddress: t("kf.dealershipEnquiry.emailAddress"),
    emailAddressError: t("kf.contactus.error.validEmail"),
    alternateMobileNumber: t("kf.productEnquiry.alternateMobileNumber"),
    spaceAvailable: t("kf.dealershipEnquiry.spaceAvailable"),
    spaceAvailableError: t("kf.dealershipEnquiry.spaceAvailableError"),
    budget: t("kf.dealershipEnquiry.budget"),
    budgetError: t("kf.dealershipEnquiry.budgetError"),
    city: t("kf.dealershipEnquiry.city"),
    cityError: t("kf.dealershipEnquiry.cityError"),
    company: t("kf.dealershipEnquiry.company"),
    companyError: t("kf.dealershipEnquiry.companyError"),
    submit: t("kf.dealershipEnquiry.submit"),
    cancel: t("kf.dealershipEnquiry.cancel"),
    dealershipSubDescription: t(
      "kf.dealershipEnquiry.dealershipSubDescription"
    ),
    dealershipPrivacyPolicyText: authorData?.dealershipPrivacyPolicyText
      ? parse(
          authorData?.dealershipPrivacyPolicyText.replaceAll("&amp;nbsp;", " ")
        )
      : t("kf.dealershipEnquiry.dealershipPrivacyPolicyText"),
    describeYourRequest: t("kf.dealershipEnquiry.describeYourRequest"),
    dealershipConfirmationText: authorData?.dealershipConfirmationText
      ? parse(
          authorData?.dealershipConfirmationText.replaceAll("&amp;nbsp;", " ")
        )
      : t("kf.dealershipEnquiry.dealershipConfirmationText"),
    dealershipConfiramtionCtaLabel: authorData?.dealershipConfiramtionCtaLabel
      ? parse(
          authorData?.dealershipConfiramtionCtaLabel.replaceAll(
            "&amp;nbsp;",
            " "
          )
        )
      : t("kf.dealershipEnquiry.dealershipConfiramtionCtaLabel"),
    errorMobileNumber: t("kf.customerSupport.error.validMobileNumber"),
    dealershipEnquiryGetOtpLabel: authorData?.dealershipEnquiryGetOtpLabel
      ? parse(
          authorData?.dealershipEnquiryGetOtpLabel.replaceAll("&amp;nbsp;", " ")
        )
      : t("kf.dealershipEnquiry.dealershipEnquiryGetOtpLabel"),
    noEmailError: t("kf.contactus.error.noEmailError"),
    verifyMobile:
      authorData?.mobileDescriptionPlaceHolder ??
      t("kf.customerSupport.verifyMobile"),
    mobileVerified:
      authorData?.mobilerNumberOtpDescription ??
      t("kf.customerSupport.mobileVerified"),
    dealershipBannerText: authorData?.dealershipBannerText ?? "",
  }

  return i18n
}

export default useDealershipEnquiry
